// Core i18n types supporting all languages from project.inlang/settings.json
export type SupportedLocale = "en" | "es" | "fr" | "de" | "ja" | "leet";
export const supportedLocales: SupportedLocale[] = ["en", "es", "fr", "de", "ja", "leet"];
export const defaultLocale: SupportedLocale = "en";

// Generic dictionary interface for modular dictionaries
export type LocaleDictionary<T extends Record<string, string>> = Record<SupportedLocale, T>;
